import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button } from '@mui/material';

const EmailBodyContent = ({ month, year, additionalInformation }) => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography paragraph>Hi {'{{expert_name}}'},</Typography>

      <Typography paragraph>We hope your week is going well!</Typography>

      <Typography paragraph>
        🎉 Please click the blue <b>&quot;View Report&quot;</b> button for your Digital PR campaign update this month!
      </Typography>

      <Button variant="contained" color="primary" sx={{ my: 1 }}>
        View report
      </Button>

      <Box
        sx={{
          border: '1px dashed',
          borderRadius: 1,
          p: 1.5,
          my: 2,
          bgcolor: 'action.hover',
          fontStyle: 'italic',
          fontSize: '0.875rem',
        }}
      >
        <Typography variant="body2" style={{ whiteSpace: 'pre-line' }}>
          {additionalInformation || '[Additional Information will appear here]'}
        </Typography>
      </Box>

      <Typography paragraph sx={{ mt: 2 }}>
        For support or questions, please reach out to your PR Specialist or reply to this email, and we will be happy to help.
      </Typography>

      <Typography paragraph>We truly value your partnership and continued trust in our team!</Typography>

      <Typography paragraph>The seoplus+ Digital PR team</Typography>
    </Box>
  );
};

EmailBodyContent.propTypes = {
  month: PropTypes.string.isRequired,
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  additionalInformation: PropTypes.string,
};

export default EmailBodyContent;
